import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import { obtenerempleadoactivo } from '../../../Redux/EmpleadoDucks'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ContenedorincidenciasAltas from './AltaIncidencias/ContenedorincidenciasAltas';
import CachedIcon from '@mui/icons-material/Cached';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { obtenermenupercepciones, obtenermenumovimientos, obtenermenuincidencias, obtenermenudeducciones, obtenermenutiporiesgo, obtenermenuramoseguro, obtenermenusecuelaconsecuencia, obtenermenucontrolincapacidad } from '../../../Redux/PdimMenuDucks'


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function SelectEmpleadoAlta(props) {
    const dispatch = useDispatch()
    const { lote } = props;
    const { empresa } = props
    const { depta } = props
    const { periodo } = props
    const { detalle } = props
    const [open, setOpen] = React.useState(false);
    const [empleado, setEmpleado] = React.useState('');

    const iddepta = depta.iddepartamento
    const [activarbotontab, setTabstatus] = React.useState(true)
    const [value, setValue] = React.useState('activo');

    const empleados = useSelector(store => store.empleado.empleadoactivo)


    const solobaja = empleados.filter(function (element) {
        return element.estadoempleado === 'Baja';
    });

    const activos = empleados.filter(function (element) {
        return element.estadoempleado !== 'Baja';
    });

    const rows = value === 'inactivo' ? solobaja : activos


    React.useEffect(() => {
        const obtenerInfo = () => {
            dispatch(obtenermenupercepciones())
            dispatch(obtenermenumovimientos())
            dispatch(obtenermenuincidencias())
            dispatch(obtenermenudeducciones())
            dispatch(obtenermenutiporiesgo())
            dispatch(obtenermenuramoseguro())
            dispatch(obtenermenusecuelaconsecuencia())
            dispatch(obtenermenucontrolincapacidad())
        }
        obtenerInfo()
    }, [dispatch])


    const handleChange = (event) => {
        setEmpleado(event.target.value);
        setTabstatus(false)
        if (event.target.value === '') {
            setTabstatus(true)
        }
    };

    const handleChangeEmpleado = (bd, dep) => {
        dispatch(obtenerempleadoactivo(bd, dep))
        setOpen(true);
    };

    const handleChangeEmpleado2 = (bd, dep) => {
        dispatch(obtenerempleadoactivo(bd, dep))
    };

    const handleClose = () => {
        setOpen(false);


    };

    return (
        <>

            <Button variant="outlined" color='success' onClick={(event) => handleChangeEmpleado(empresa, iddepta)}>
                <AddIcon />   Empleado
            </Button>

            <BootstrapDialog
                fullWidth={true}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                justifycontent='space-around'
                maxWidth={'lg'}
            >
                <Typography align='left' style={{ padding: '16px' }}>
                    Departamento: {depta.descripcion}
                </Typography>
                <DialogContent dividers>
                    <Grid container spacing={3} justifycontent='space-around' >
                        <Grid item md={4}>
                            <Typography gutterBottom variant='h6'>
                                Empleado <IconButton aria-label="delete" onClick={e => handleChangeEmpleado2(empresa, iddepta)}>
                                    <CachedIcon />
                                </IconButton>
                            </Typography>

                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={value}
                                    onChange={e => setValue(e.target.value)}

                                >

                                    <FormControlLabel value="activo"
                                        control={<Radio sx={{
                                            color: '#688716',
                                            '&.Mui-checked': {
                                                color: '#688716',
                                            },
                                        }} />} label="Activos" />
                                    <FormControlLabel value="inactivo"
                                        control={<Radio sx={{
                                            color: '#688716',
                                            '&.Mui-checked': {
                                                color: '#688716',
                                            },
                                        }} />} label="Inactivos" />
                                </RadioGroup>
                            </FormControl>


                            <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                                <InputLabel id="demo-simple-select-autowidth-label">Empleado</InputLabel>
                                <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={empleado}
                                    onChange={handleChange}
                                    autoWidth
                                    label="idempleado"
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {
                                        rows.map((row, Index) => (
                                            <MenuItem key={Index} value={row}>{row.codigoempleado + " - " + row.nombrelargo}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item >
                            <Typography gutterBottom variant='h6'>
                                Incidencias
                            </Typography>
                            <Typography gutterBottom variant='body2'>
                                Indica las incidencias del empleado
                            </Typography>

                            <ContenedorincidenciasAltas
                                idempleado={empleado.idempleado}
                                empleadodepta={empleado.iddepartamento}
                                lote={lote}
                                datotodoempleado={empleado}
                                periodo={periodo}
                                activarbotontab={activarbotontab}
                                detalle={detalle}
                            />
                        </Grid>
                    </Grid>


                </DialogContent>
                <DialogActions>

                    <Button variant='outlined' color='success' onClick={handleClose}>
                        Cerrar
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    );
}
